import CustomText from "@components/CustomText";
import { colors } from "@constants/theme";
import ChevronRight from "@assets/svg/ChevronRight";
import TickCircle from "@assets/svg/ShopPerformance/TickCircle";
import CircleInfo from "@assets/svg/MyDeliveries/CircleInfo";

import React from "react";
import { TouchableOpacity, StyleSheet, View, Image } from "react-native";

function CrateListCard({ crate, navigation, route, type }) {
  function TagText({ text, containerStyle, textStyle }) {
    return (
      <View style={[styles.tagTextContainer, containerStyle]}>
        <CustomText variant="body_text_3" style={[styles.tagText, textStyle]}>
          {text}
        </CustomText>
      </View>
    );
  }
  return (
    <TouchableOpacity
      testID="sd-crate-list-card"
      disabled={!crate?.navigate}
      onPress={() => {
        navigation.navigate("CrateCustomerList", {
          crate,
          spoke: route?.params?.spokeName,
          date: route?.params?.date,
          type,
        });
      }}
      activeOpacity={0.6}
      style={styles.itemContainer}
    >
      <View>
        <View style={styles.titleAndTag}>
          <CustomText variant="subtitle_16">{crate?.label}</CustomText>
          <View style={styles.tagSpacer} />
          {crate?.is_large_items_crate ? (
            <TagText
              text="Large"
              textStyle={{ color: colors.black, fontSize: 12, lineHeight: 18 }}
              containerStyle={{
                backgroundColor: "rgba(255, 214, 0, 1)",
                paddingHorizontal: 10,
                paddingVertical: 0,
              }}
            />
          ) : null}
        </View>
        <View style={styles.tagContainer}>
          <TagText text={`${crate?.customer_count} Customers`} />
          <View style={styles.tagSpacer} />
          <TagText text={`${crate?.item_count} Items`} />
        </View>
      </View>
      <View style={styles.iconContainer}>
        {crate?.product_image ? (
          <Image
            source={{ uri: crate?.product_image }}
            style={styles.image}
            resizeMode="contain"
          />
        ) : null}
        {crate?.status === "PACKED" ? (
          <TickCircle height={25} width={25} />
        ) : crate?.status === "PACKING" ? (
          <CircleInfo height={25} width={25} />
        ) : null}
        <View style={styles.iconSpacer} />
        {crate?.navigate && (
          <ChevronRight height={14} width={14} pathFill={colors.darkGrey} />
        )}
      </View>
    </TouchableOpacity>
  );
}

export default CrateListCard;
const styles = StyleSheet.create({
  itemContainer: {
    backgroundColor: colors.white,
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    paddingVertical: 14,
    borderRadius: 10,
    marginHorizontal: 14,
    marginVertical: 10,
    alignItems: "center",
    elevation: 1,
  },
  titleAndTag: {
    flexDirection: "row",
    alignItems: "center",
  },
  tagContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: 4,
  },
  tagSpacer: {
    width: 8,
  },
  iconContainer: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  iconSpacer: {
    width: 4,
  },
  tagTextContainer: {
    backgroundColor: colors.lightGrey,
    paddingHorizontal: 6,
    paddingVertical: 1,
    borderRadius: 10,
  },
  tagText: {
    color: colors.mediumBlack,
  },
  image: {
    marginRight: 12,
    height: 43,
    width: 43,
    borderWidth: 1,
    borderColor: colors.lighterBlack,
    borderRadius: 8,
  },
});
